interface NewsHeroImageProps {
    src: string;
    alt: string;
}

const DEFAULT_FALLBACK_IMAGE = "https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=1920&q=80";

export const NewsHeroImage = ({ src, alt }: NewsHeroImageProps) => {
    return (
        <div className="relative w-full h-70 md:h-85 lg:h-105 mb-12">
            <img
                src={src}
                alt={alt}
                width={1920}
                height={1080}
                fetchPriority="high"
                decoding="async"
                className="w-full h-full object-cover"
                onError={e => {
                    e.currentTarget.src = DEFAULT_FALLBACK_IMAGE;
                }}
            />
            <div className="absolute inset-0 bg-linear-to-t from-background via-background/50 to-transparent" />
        </div>
    );
};
